import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	type?: 'login' | 'large' | 'small' | 'extra-small' | 'tiny' | 'extra-tiny' | 'loginSecondary';
	'data-testid'?: string;
}

export class LoadingSpinner extends React.PureComponent<IProps> {
	public render() {
		const { type, className, 'data-testid': dataTestId } = this.props;
		let spinnerStyle = styleSheet.loadingSmall;
		switch (type) {
			case 'large': {
				spinnerStyle = styleSheet.loadingLarge;
				break;
			}
			case 'login': {
				spinnerStyle = styleSheet.loadingLogin;
				break;
			}
			case 'loginSecondary': {
				spinnerStyle = styleSheet.loadingLoginSecondary;
				break;
			}
			case 'tiny': {
				spinnerStyle = styleSheet.loadingTiny;
				break;
			}
			case 'extra-tiny': {
				spinnerStyle = styleSheet.loadingExtraTiny;
				break;
			}
			case 'extra-small': {
				spinnerStyle = styleSheet.loadingExtraSmall;
				break;
			}
			default: {
				spinnerStyle = styleSheet.loadingSmall;
				break;
			}
		}
		return (
			<div className={`loading-spinner ${className || ''}`} role='loading-spinner' data-testid={dataTestId}>
				<div className={`loading-spinner-spinner ${css(spinnerStyle)}`} />
			</div>
		);
	}
}
